<img
  *ngIf="currencyIcon"
  class="currency-icon"
  [ngClass]="{ 'currency-icon-dark': isDarkColorScheme$ | async }"
  [src]="currencyIcon"
  [alt]="alt"
/>
